<template>
  <div class="item-unavailable-summary grid-x grid-margin-x small-margin-bottom-l large-margin-bottom-xxl small-padding-xs medium-padding-z">
    <div class="image-container cell shrink small-margin-right-xs medium-margin-right-s">
      <img v-if="primaryImagePath" :src="primaryImagePath" :alt="productName" class="product-image" />
    </div>

    <div class="details-container">
      <div class="h6 unavailable-title margin-bottom-xxs">This item is unavailable</div>

      <div class="product-lockup margin-bottom-md">
        <UnavailableProductTitle />
      </div>

      <button
        href="#product-card-details"
        class="view-details pill-button small-margin-top-xxs medium-margin-top-xs"
        @click.prevent="scrollToDetails"
      >
        Full details
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useImages from '~/composables/images/useImages';
import { useCommonProductGetters } from '~/composables/useCommonProductGetters';
import { fireLinkTag } from '~/features/analytics/tagManager';
import once from '~/utils/once';
import UnavailableProductTitle from '~/components/productTitle/UnavailableProductTitle.vue';
const { primaryImageData } = useImages();
const { productName } = useCommonProductGetters();

const fireAnalyticsOnce = once((payload) => fireLinkTag(payload));
const primaryImagePath = computed(() => primaryImageData.value?.path || '');

const scrollToDetails = () => {
  const el = document.getElementById('product-card-details');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  return fireAnalyticsOnce({
    event_name: 'pdp unavailable full details',
    link_name: 'pdp unavailable full details',
  });
};
</script>




<style lang="scss" scoped>
@import '~settingSCSS';
@import '~@core/csg/src/scss/components/pill-button-mixin.scss';
@include csg-pill-button;

.item-unavailable-summary {
  margin-top: rem-calc(16);
  flex-wrap: nowrap;

  @include breakpoint(small only) {
    background-color: $background-color;
  }
}

.view-details {
  width: fit-content;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;

  @include breakpoint(medium up) {
    margin-bottom: 0;
  }

  .product-image {
    max-width: 100%;
    max-height: rem-calc(206);
    height: auto;
    object-fit: contain;

    @include breakpoint(small only) {
      max-height: rem-calc(137);
    }
  }
}

.details-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.view-details-link {
  font-size: rem-calc(16);
  text-decoration: underline;
  cursor: pointer;
  color: $black;

  &:hover {
    text-decoration: none;
  }
}
.unavailable-title {
  color: $black;
}


@import '~settingSCSS';
.item-unavailable-summary {
  border-radius: rem-calc(5);
}
.product-image {
  border-radius: rem-calc(5);
}
</style>